import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { ChangeStockItemModel, StockItem, StockItemsQuery } from "../../inventory/models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class CustomerStockItemsApi {
  getStockItems(query: StockItemsQuery): Promise<Page<StockItem>> {
    return api.get<Page<StockItem>>(
      `/v1/stock-items`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getStockItem(id: string): Promise<StockItem> {
    return api.get<StockItem>(`/v1/stock-items/${id}`, getRequestConfig())
      .then(x => x.data);
  }

  createStockItem(model: ChangeStockItemModel): Promise<string> {
    return api.post<string>(`/v1/stock-items`, model, getRequestConfig())
      .then(x => x.data);
  }

  changeStockItem(id: string, model: ChangeStockItemModel): Promise<any> {
    return api.put<any>(`/v1/stock-items/${id}`, model, getRequestConfig())
      .then(x => x.data);
  }

  moveStockItemsToGroup(groupId: string, ids: string[]): Promise<any> {
    return api.put<any>(`/v1/stock-items/groups/${groupId}`, ids, getRequestConfig())
      .then(x => x.data);
  }

  deleteStockItem(id: string): Promise<any> {
    return api.delete(`/v1/stock-items/${id}`, getRequestConfig());
  }

  deleteStockItems(ids: string[]): Promise<any> {
    return api.post(`/v1/stock-items/delete-bulk`, ids, getRequestConfig());
  }
}

export default new CustomerStockItemsApi();
